<template>
	<div>
		<HeaderBar title="既往史"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group title="吸烟史">
					<StaticSingleSelect label="是否吸烟" :selectkey.sync="form.bq401.bq401003" :list="bq401003List">
					</StaticSingleSelect>
					<FormAppendInput v-show="form.bq401.bq401003=='吸烟'" v-model="form.bq401.bq401004" appendText="年"
						placeholder="抽烟多少年">
					</FormAppendInput>
					<FormAppendInput v-show="form.bq401.bq401003=='吸烟'" appendText="支/天" v-model="form.bq401.bq401005"
						placeholder="多少支/天">
					</FormAppendInput>
					<!--        <van-cell>
          <template #title>
            <span class="followRecord-title">{{form.bq401.bq401003}}</span>
            <span v-show="form.bq401.bq401003=='吸烟'">
              <van-tag type="danger" class="followRecord-tag">{{form.bq401.bq401004}}年
              </van-tag>
              <van-tag type="danger" class="followRecord-tag">{{form.bq401.bq401005}}支/天
              </van-tag>
            </span>
          </template>
        </van-cell> -->
				</van-cell-group>

				<van-cell-group title="饮酒史">
					<StaticSingleSelect label="是否饮酒" :selectkey.sync="form.bq401.bq401006" :list="bq401006List">
					</StaticSingleSelect>
					<FormAppendInput v-show="form.bq401.bq401006=='饮酒'" v-model="form.bq401.bq401007" appendText="年"
						placeholder="饮酒多少年">
					</FormAppendInput>
					<FormAppendInput v-show="form.bq401.bq401006=='饮酒'" label="折合酒精平均" appendText="g/天"
						v-model="form.bq401.bq401008" placeholder="多少g/天">
					</FormAppendInput>
					<!--        <van-cell>
          <template #title>
            <span class="followRecord-title">{{form.bq401.bq401006}}</span>
            <span v-show="form.bq401.bq401006=='饮酒'">
              <van-tag type="danger" class="followRecord-tag">{{form.bq401.bq401007}}年
              </van-tag>
              <van-tag type="danger" class="followRecord-tag">折合酒精平均{{form.bq401.bq401008}}g/天
              </van-tag>
            </span>
          </template>
        </van-cell> -->
				</van-cell-group>

				<van-cell-group title="输血史">
					<StaticSingleSelect label="有无输血史" :selectkey.sync="form.bq401.bq401009" :list="existList">
					</StaticSingleSelect>
					<StaticSingleSelect v-show="form.bq401.bq401009=='有'" label="哪一年"
						:selectkey.sync="form.bq401.bq401010" :list="yearList">
					</StaticSingleSelect>
					<!--        <van-cell>
          <template #title>
            <span class="followRecord-title">{{form.bq401.bq401009}}</span>
            <span v-show="form.bq401.bq401009=='有'">
              <van-tag type="danger" class="followRecord-tag">{{form.bq401.bq401010}}年
              </van-tag>
            </span>
          </template>
        </van-cell> -->
				</van-cell-group>

				<van-cell-group title="高血压">
					<StaticSingleSelect label="有无高血压" :selectkey.sync="form.bq401.bq401011" :list="existList">
					</StaticSingleSelect>
					<!--        <van-cell>
          <template #title>
            <span class="followRecord-title">{{form.bq401.bq401011}}</span>
          </template>
        </van-cell> -->
				</van-cell-group>

				<van-cell-group title="糖尿病">
					<StaticSingleSelect label="有无糖尿病" :selectkey.sync="form.bq401.bq401012" :list="existList">
					</StaticSingleSelect>
					<!--        <van-cell>
          <template #title>
            <span class="followRecord-title">{{form.bq401.bq401012}}</span>
          </template>
        </van-cell> -->
				</van-cell-group>

				<FormNormalUpload label="上传报告" ref="normalUpload" :infoGuid='form.bq401.guid'></FormNormalUpload>

				<div class="page-bottom-box" style="margin: 16px;">
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq401.guid!=''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>
			</van-form>
		</div>
	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../base/components.js'
	export default {
		name: "page",
		data() {
			return {
				form: {
					bq401: {
						id: "0", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						extend1: "", //扩展字段
						extend2: "", //扩展字段
						extend3: "", //扩展字段
						extend4: "", //扩展字段
						extend5: "", //扩展字段
						bq001018: "", //患者身份证编号
						bq401003: "", //是否吸烟，不吸烟，1-吸烟
						bq401004: "", //吸烟年限
						bq401005: "", //日平均
						bq401006: "", //是否饮酒，不饮酒，饮洒
						bq401007: "", //喝酒年限
						bq401008: "", //日平均
						bq401009: "", //输血史，有，无
						bq401010: "", //输血年份
						bq401011: "", //高血压，有，无
						bq401012: "", //糖尿病，有，无
						Bq001_018: '', //患者身份证编号
						Bq401_003: '', //是否吸烟，不吸烟，1-吸烟
						Bq401_004: '', //吸烟年限
						Bq401_005: '', //日平均
						Bq401_006: '', //是否饮酒，不饮酒，饮洒
						Bq401_007: '', //喝酒年限
						Bq401_008: '', //日平均
						Bq401_009: '', //输血史，有，无
						Bq401_010: '', //输血年份
						Bq401_011: '', //高血压，有，无
						Bq401_012: '', //糖尿病，有，无
					}
				},
				// 抽烟数组
				bq401003List: [],
				// 饮酒数组
				bq401006List: [],
				// 有/无数组
				existList: [],
				// 年份数组
				yearList: [],
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq401/Save',
				bq400: JSON.parse(sessionStorage.getItem('bq400')) //获取随访信息
			}
		},
		components: {
			...componentsModel,

		},
		methods: {
			//保存按钮成功回调事件
			saveSucess: function() {
				//调用列表页的closeDialog方法
				// this.Back()
			},
			//加载信息
			LoadInfo: function() {
				var that = this
				var args={
					bq001018:that.bq400.Bq001_018
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq401/Info' ,args, function(d) {
					
					let dataModel = d.Data
					that.$utils.CopyKeyInfo(dataModel,dataModel)
					that.$utils.CopyPro(dataModel, that.form.bq401)
				}, null, null, null);
			},
			//保存信息
			SaveInfo: function() {
				let that = this
				that.$utils.CopyKeySave(that.form.bq401,that.form.bq401)
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},

		},
		mounted() {
			let that = this
			// 预处理下拉数组
			that.bq401003List = that.$utils.setStandardList(that.$apis.s400Apis.bq401003List)
			that.bq401006List = that.$utils.setStandardList(that.$apis.s400Apis.bq401006List)
			that.existList = that.$utils.setStandardList(that.$apis.s400Apis.existList)
			that.yearList = that.$utils.setStandardList(that.$utils.getYearList(30))

			that.form.bq401.bq001018 = that.bq400.bq001018
			this.LoadInfo()
			this.Resize()
		}
	}
</script>

<style scoped>
	.followRecord-title {
		padding-right: 10px;
	}

	.followRecord-tag {
		margin-right: 10px;
	}
</style>
